export const ItemTypes = {
  LECTURE_LISTING: "LECTURE_LISTING",
};
